const accordion = () => {

    var acc = document.getElementsByClassName('accordion');
    var i;
    
    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener('click', function () {
            Array.from(acc).forEach((el) => {
                if (this !== el) {
                    el.classList.remove('active');
                    var panel = el.nextElementSibling;
                    panel.style.maxHeight = null;
                }
            });
            this.classList.toggle('active');
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + 'px';
            }
        });
    }
}

export default accordion;